module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-SPORT-2.4c848e07.jpg";